const PinLineFill = ({ className = '', ...props }) => {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M18.7596 9.33046L17.5804 10.5088L16.9913 9.91962L13.4563 13.4546L12.8671 16.4013L11.6879 17.5796L8.15294 14.0438L4.02794 18.1688L2.84961 16.9905L6.97461 12.8655L3.43878 9.33046L4.61711 8.15129L7.56461 7.56212L11.0996 4.02712L10.5104 3.43796L11.6888 2.25879L18.7596 9.33046Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default PinLineFill;
